import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { updateCompanySettings } from "../../../../../../../export/gat-admin";
import { findDifferentKeys } from "../../../../../../components/gat-admin/utils";
import useGatAdminConfigData from "../../../../controllers/use-gat-admin-config-data";
import { Setting } from "../../../../store/gat-admin-slice-types";

const settingsObj: { [key: string]: string } = {
	supervisorAppEnabled: "supervisorMobileApp.enabled",
	aiFeaturesEnabled: "supervisorMobileApp.aiFeatures.enabled",
};

const initialSupervisorAppSettings = {
	supervisorAppEnabled: false,
	aiFeaturesEnabled: false,
};

const useSupervisorAppController = (companyId: number) => {
	const dispatch = useDispatch();

	const { companySettingsObj, updateCompanySettingsStatus, getCompanySettingsStatus } =
		useGatAdminConfigData();

	const [loading, setLoading] = useState(false);

	const [supervisorAppSettings, setSupervisorAppSettings] = useState(
		initialSupervisorAppSettings
	);
	const [newSupervisorAppSettings, setNewSupervisorAppSettings] = useState<any>({});

	const buildSetting = (code: string, value: boolean): Setting => {
		const existing = companySettingsObj[code];
		if (existing) {
			return { ...existing, value };
		}
		// Setting not yet present on the company — construct it.
		return {
			code,
			entity: "company",
			entityId: companyId,
			type: "System.Boolean",
			value,
		};
	};

	const handleSave = () => {
		setLoading(true);
		const diffKeys: string[] = findDifferentKeys(
			supervisorAppSettings,
			newSupervisorAppSettings
		);
		const changedSettings = diffKeys.map((key) =>
			buildSetting(settingsObj[key], newSupervisorAppSettings[key])
		);
		dispatch(updateCompanySettings(changedSettings));
	};

	useEffect(() => {
		if (Object.keys(companySettingsObj).length > 0) {
			const obj = {
				supervisorAppEnabled:
					companySettingsObj["supervisorMobileApp.enabled"]?.value ?? false,
				aiFeaturesEnabled:
					companySettingsObj["supervisorMobileApp.aiFeatures.enabled"]?.value ??
					false,
			};
			setSupervisorAppSettings(obj);
			setNewSupervisorAppSettings(obj);
		}
	}, [companySettingsObj]);

	useEffect(() => {
		if (updateCompanySettingsStatus === "fulfilled" && loading) {
			setSupervisorAppSettings(newSupervisorAppSettings);
			setLoading(false);
		}
	}, [updateCompanySettingsStatus, newSupervisorAppSettings, loading]);

	return [
		{
			supervisorAppSettings,
			newSupervisorAppSettings,
			loading,
			getCompanySettingsStatus,
		},
		{
			setNewSupervisorAppSettings,
			handleSave,
		},
	] as const;
};

export default useSupervisorAppController;
